import VideoIconPurple from '@lib/core/src/assets/buttons-icons/video-icon-purple.svg?react';
import VideoIconWhite from '@lib/core/src/assets/buttons-icons/video-icon-white.svg?react';
import palette from '@lib/core/src/theme/palette';
import { Button, styled } from '@mui/material';

const ACTIVE_BACKGROUND =
  'linear-gradient(47deg, #366EE9 0%, #AF83F9 36.54%, #715DE6 66.83%, #7E4CDC 100%)';

const INACTIVE_BACKGROUND =
  'linear-gradient(47deg, rgba(54, 110, 233, 0.10) 0%, rgba(175, 131, 249, 0.10) 36.54%, rgba(113, 93, 230, 0.10) 66.83%, rgba(126, 76, 220, 0.10) 100%)';

const HOVER_BACKGROUND =
  'linear-gradient(47deg, rgba(54, 110, 233, 0.20) 0%, rgba(175, 131, 249, 0.20) 36.54%, rgba(113, 93, 230, 0.20) 66.83%, rgba(126, 76, 220, 0.20) 100%)';

const ButtonContainer = styled(Button, {
  shouldForwardProp: prop => prop !== 'isActive'
})<{ isActive: boolean }>(({ isActive }) => ({
  color: isActive ? palette.white : palette.purple[300],
  borderRadius: '11px',
  fontSize: '11px',
  fontWeight: '500',
  height: '18px',
  lineHeight: '18px',
  textTransform: 'none',
  gap: '4px',
  background: isActive ? ACTIVE_BACKGROUND : INACTIVE_BACKGROUND,
  '&:hover': {
    ...(!isActive && {
      background: HOVER_BACKGROUND
    })
  }
}));

interface InviteBotButtonProps {
  isActive: boolean;
  inviteBot: () => void;
}

const InviteBotButton = ({ isActive, inviteBot }: InviteBotButtonProps) => (
  <ButtonContainer isActive={isActive} onClick={inviteBot}>
    {isActive ? (
      <>
        <VideoIconWhite />
        JourneyAI Invited
      </>
    ) : (
      <>
        <VideoIconPurple />
        Invite JourneyAI
      </>
    )}
  </ButtonContainer>
);

export default InviteBotButton;
